import axios          from "@/axios/axios";
import arrayToIdIndex from "../helpers/arrayToIdIndex";

let _list = null;
let _dict = null;
let _loader = null;

const loadList = () => {
  if (!_loader) _loader = axios.get('devices_type').then(( { data } ) => {
    _dict = arrayToIdIndex(data);
    for (let id in types) {
      _dict[id] = { ..._dict[id], ...types[id] };
    }
    _list = Object.values(_dict);
  });
  return _loader;
};

export const getList = () => loadList().then(() => _list);

export const getDict = () => loadList().then(() => _dict);

export const getById = ( id ) => loadList().then(() => _dict[id] || unknownType);

const unknownType = {
  id:   -1,
  name: "Не известен",
};

export const groups = [
  'WATER_ALL',
  'WATER_COLD',
  'WATER_HOT',
  'ELECTRICITY',
  'GAS',
  'HEATING',
];

const types = {
  9997: {
    id:         9997,
    icon:       "ElectricityIcon",
    icon_color: "warning",
    name:       "Электричество",
    full_name:  "Электричество",
  },
  9998: {
    id:         9998,
    icon:       "ElectricityIcon",
    icon_color: "warning",
    name:       "Электричество (день/ночь)",
    full_name:  "Электричество (день/ночь)",
  },
  9999: {
    id:         9999,
    icon:       "ElectricityIcon",
    icon_color: "warning",
    name:       "Электричество (день/ночь/пик)",
    full_name:  "Электричество (день/ночь/пик)",
  },
};
